import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
const DataRetention = () => {
  return (
    <>
      <PrivacyPolicyContainer>
        <h3>Data Retention</h3>

        <p>
          We retain personal information only for as long as reasonably
          necessary to provide our services, maintain appropriate business and
          training records, fulfill the purposes described in this Privacy
          Policy, and meet applicable legal, regulatory, accounting, security,
          and contractual requirements.
        </p>

        <p>
          Retention periods may vary depending on the type of information and
          the purpose for which it is maintained. For example, we may retain
          account information, training history, course completion records, quiz
          or assessment results, certificates, transaction records, company
          training records, digital safety form entries, and related
          documentation for different periods based on operational, contractual,
          legal, or record-keeping requirements.
        </p>

        <p>
          When personal information is no longer reasonably required for the
          purposes for which it was collected or for applicable legal or
          business requirements, we will take reasonable steps to delete,
          anonymize, or otherwise securely dispose of the information, where
          appropriate.
        </p>
      </PrivacyPolicyContainer>

      <PrivacyPolicyContainer>
        <h3>Storage and Processing of Information</h3>

        <p>
          Yoda Safety Services uses third-party service providers to operate and
          support our website, training platform, and services. As a result,
          personal information may be stored or processed using infrastructure
          operated by service providers located in Canada, the United States, or
          other jurisdictions.
        </p>

        <p>
          When personal information is processed or stored outside your
          province, territory, or country, it may be subject to the laws of the
          jurisdiction in which it is processed or stored and may be accessible
          to courts, law enforcement, regulatory authorities, or other
          government authorities in accordance with applicable law.
        </p>

        <p>
          We use service providers where reasonably necessary to operate our
          services and take reasonable steps to select and use providers
          appropriate for the nature of the information and services involved.
        </p>
      </PrivacyPolicyContainer>

      <PrivacyPolicyContainer>
        <h3>Consent</h3>

        <p>
          Where required by applicable privacy law, Yoda Safety Services obtains
          consent for the collection, use, or disclosure of personal
          information. Consent may be express or implied depending on the
          circumstances, the sensitivity of the information, and the reasonable
          expectations of the individual.
        </p>

        <p>
          In some circumstances, personal information may be collected, used, or
          disclosed without consent where permitted or required by law.
        </p>

        <p>
          You may withdraw consent where our handling of personal information is
          based on consent, subject to legal or contractual restrictions and
          reasonable notice. Withdrawal of consent may affect our ability to
          provide certain services or platform functionality.
        </p>
      </PrivacyPolicyContainer>
    </>
  );
};

export default DataRetention;
